export default {
  install(Vue, options) {
    Vue.prototype.$Manage = {
      ManagerAccountList:[],
      TimeZoneList:[],
      UserLevel:[],
      ProtocolUnitList:[],
      ServerPortList:[],
      IconTypeList:[],
      ObjectTypeList:[],
      DriverList:[],
      POIIconList:[],
      OBDTypeList:[],
      ACCTypeList :[],
      GetfleetsTreeNum:0,
      ManageGroupShowNum:0,
      ManageGroupShow:false,
      ManageGroupAddMessage:'',
      ManageGroupEditMessage:'',
      ManageGroupType:'add',
      ManageGroupObj:{
        fleetName:'',parentFleetID:-1,googleAPIkey:'',Timezone:0,modifyUser:'',
        VIPPhones:'',VIPPhonetext:'',
        WhatsAPPPhones:'',WhatsAPPPhonetext:'',
        VIPEmails:'',VIPEmailtext:'',uploadsrc:'',LineToken:null,LineMode:null,DefaultMap:0,ExtraFleetList:[],linePushNotificationLimits:false
      },
      GetManageAccountNum:0,
      ManageAccountShowNum:0,
      ManageAccountShow:false,
      ManageAccountType:'add',
      ManageAccountObj:{
        UserID:'',account:'',password:'',encode:false,userLevel:-1,firstName:'',lastName:'',phoneNumber:'',email:'',primaryFleetId:0,primaryFleetTimeZone:'',active:0,expiredDate:'',modifyUser:'',unitIDList:''
      },
      GetManageVehicleNum:0,
      ManageVehicleShowNum:0,
      ManageVehicleShow:false,
      ManageVehicleType:'add',
      ManageVehicleObj:{
        analog1:0,analog2:0,fuelRate:0,fuelRateUnit:'',objectID:0,description:'',unitID:'',plateNumber:'',unitProtocol:0,serverPort:0,objectType:0,fleet:0,iconType:0,modifyUser:'',IMEI:'',ModemID:'',driverID:0,note:'',unitSIMPhoneNumber:'',OBDType:0,useACC:1,accType:1,offlineThreshold:3,active:0,expiredDate:'',pdfBillUrl:'',files:'',
        TSI1:null,TSI2:null,TSI3:null,TSI4:null,OneWireJSON:null,TSI1Name:null,TSI2Name:null,TSI3Name:null,TSI4Name:null,LensCount:null,MDVRJSON:null,MDVRID:null,mode:1,Manufacturer:'',EngineNumber:'',
        imei:'',iccid:'',imsi:'',model_Name:'',fW_Version:'',hW_Version:'',infoUpdateDateTime:'',volume:'',total_volume:'',expiry_date:'',last_status_change_date:''
      },
      GetManageDriverNum:0,
      ManageDriverShowNum:0,
      ManageDriverShow:false,
      ManageDriverType:'add',
      ManageDriverObj:{
        customerID:'',modifyUser:'',driverName:'',birthday:null,sex:0,bloodType:0,driverLicenseNo:'',driverLicenseType:'',driverLicenseExpired:null,contactPhone:'',contactEmail:'',address:'',RFID:'',fleet:0,co_Driver:'',note:''
      },
      GetManagePOINum:0,
      ManagePOIShowNum:0,
      ManagePOIShow:false,
      ManagePOIType:'add',
      ManagePOIObj:{
        POIID:'',pointName:'',discription:'',centerX:'',centerY:'',iconSelect:0,active:1,modifyUser:'',inherit:false
      },
      GetManageGFNum:0,
      ManageGFShowNum:0,
      ManageGFShow:false,
      ManageGFType:'add',
      ManageGFObj:{
        ZoneName : "",SpeedLimit: 0,StayLimit: 0,FK_FleetID: 0,GeoType: "",GeoNodes: "",Bound_Xmin: 0,Bound_Ymin: 0,Bound_Xmax: 0,Bound_Ymax: 0,active:1
      },
      ManageGFASShow:false,
      GetManageATCommandNum:0,
      ManageATCommandShowNum:0,
      ManageATCommandShow:false,
      ManageATCommandType:'add',
      ManageATCommandObj:{
        pK_CommID:0,inherit:false,name:'',ProtoID:0,syntax:'',description:'',active:1
      },
      ManageATCommandASShow:false,
      GetManageSBCJNum:0,
      ManageSBCJShowNum:0,
      ManageSBCJShow:false,
      SBCJAssigned:[],
      AssignManageSBCJShowNum:0,
      AssignManageSBCJShow:false,
      AssignManageSBCJ_JobID:0,
      StatusManageSBCJShowNum:0,
      StatusManageSBCJShow:false,
      StatusManageSBCJ_JobID:0,
      ManageSBCJType:'add',
      ManageSBCJObj:{
        JobID:0,FirmwareID:0,Command:'',Command2:'',Description:'',ExpiredDate:'',TryTimes:'',Active:1
      },
      GeofenceAssignPage:'Geofenceupload',
      treeData: {},
      UnitArr:[],
      GeofenceBatchAsignAll:false,
      BatchCommandPage:'FirmwareUpload',
      BCFirmwareUploadFile:'',
      GetBCBatchCommandNum:0,
      BCBatchCommandShowNum:0,
      BCBatchCommandShow:false,
      SBCJAssigned:[],
      AssignBCBatchCommandShowNum:0,
      AssignBCBatchCommandShow:false,
      AssignBCBatchCommand_JobID:0,
      StatusBCBatchCommandShowNum:0,
      StatusBCBatchCommandShow:false,
      StatusBCBatchCommand_JobID:0,
      BCBatchCommandType:'add',
      BCBatchCommandObj:{
        JobID:0,FirmwareID:0,Description:'',ExpiredDate:'',TryTimes:'',Active:1,type:0,command:'',command2:'',command3:''
      },
      BatchCommandAssigned:[],
      BCUnitArr:[],
      BCUnitArrAll:[],
      BCAsignAll:false,
      //MaintenanceSchedule Variable
      MaintenanceScheduleShow:false,
      MaintenanceScheduleShowNum:0,
      MaintenanceScheduleObj:{
        ObjectID:null,V4MaintItemID:null,SchDateTime:null,SchMileage:null,PerDays:null,PerMileage:null,PerHours:null,Description:null,Note:null,PK_MaintTaskID:null
      },
      MaintenanceScheduleType:'add',
      delUnitBindLineUserSuccessNum:0,
      delUnitBindLineGroupSuccessNum:0
    }
  }
}




// WEBPACK FOOTER //
// ./src/Manage.js